// Attaches the stored JWT to requests for customer-scoped endpoints.
const authHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export default authHeader;
